// SQLITE IMPORTS
import { Plugins } from "@capacitor/core";
import { SQLiteConnection } from "@capacitor-community/sqlite";

// JSON FILE WITH DATA
import jsonData from "./import-json";

const { CapacitorSQLite } = Plugins;

const mSQLite = new SQLiteConnection(CapacitorSQLite);
let database: any;

//Si no existe daatabase se crea y se importa el json

const loadJSON = async () => {
    return await mSQLite.importFromJson(JSON.stringify(jsonData));
};

//se inicializa la base de datos

export const initdb = async () => {
    try {

        const ret = await mSQLite.checkConnectionsConsistency()
        const isConn = (await mSQLite.isConnection('ariposappdb', false)).result

        if (ret.result && isConn) {
            database = await mSQLite.retrieveConnection("ariposappdb", false)
        } else {
            database = await mSQLite.createConnection(
                "ariposappdb",
                false,
                "no-encryption",
                1, false
            );
            // load the default contacts
            await loadJSON();

        }

        return database

    } catch (e) {
        //window.alert(e);
        console.log(e);
        return null;
    }
};

//-------------------------------------se generan consultas a la base de datos

//LOCACIONES

export const queryAllLocations = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from locations order by id desc;");
    }

};

export const createLocationTest = async () => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO locations (id, lat, lng, datetime) VALUES( ?, ?, ?, ?)",
        [
            null,
            '12.11966704341231',
            '-86.23124409076823',
            'test'
        ]
    );
};

//CONFIGURACION

export const createConfiguration = async (data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO configurations (id, token, data_login) VALUES( ?, ?, ?)",
        [
            null,
            data.token,
            data.data_login,
        ]
    );
};

export const updateConfigurationById = async (id: any, data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.query(
        "UPDATE configurations SET token =?, data_login =? WHERE id = ?;",
        [
            data.token,
            data.data_login,
            id + ""
        ]
    );
};

export const deleteConfigurationById = async (id: any) => {
    if (!database) {
        await initdb();
    }
    return await database.query("DELETE FROM configurations WHERE id = ?;", [
        id + ""
    ]);

};

export const getConfigurationById = async (id: any) => {
    if (!database) {
        await initdb();
    }
    await database.open();
    return await database.query("SELECT * FROM configurations WHERE id = ?;", [
        id + "",
    ]);

};

export const queryAllConfiguration = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from configurations order by id desc;");
    }

};

//PERMISSIONS

export const queryAllPermisions = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from permissions order by id desc;");
    }

};


export const createPermission = async () => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO permissions (id, name, status) VALUES( ?, ?, ?)",
        [
            null,
            'permiso2',
            'desactive',
        ]
    );
};

//ACTIVITIES
export const createActivitie = async (data: any) => {
    if (!database) {
        await initdb();
    }
    return await database.run(
        "INSERT INTO activities (id, log_name, description, date, user_id, other) VALUES( ?, ?, ?,?, ?, ?)",
        [
            null,
            data.log_name,
            data.description,
            data.date,
            data.user_id,
            ''
        ]
    );
};
export const queryAllActivities = async () => {
    const ret = await mSQLite.checkConnectionsConsistency()
    const isConn = (await mSQLite.isConnection('ariposappdb', false)).result;

    if (ret.result && isConn) {
        // open database
        await database.open();
        return database.query("SELECT * from activities order by id desc;");
    }

};